import React, {useEffect} from 'react';
import {Layout, Page} from '@phonectas/unifon-ui-kit';
import TicketForm from '../components/form/TicketForm';
import {useTranslation} from 'react-i18next';
import SlideInWarnings from 'common/components/SlideInWarnings/indext';
import useBmoStore from 'common/stores/bmoStore';

const CreateTicketTab: React.FC = () => {
	const [t] = useTranslation();
	const telenorApiWarning = t('Telenor Error: Make sure the reported phone number is a Unifon number (provider code 819).');
	const error = useBmoStore((state) => state.error);
	const clearError = useBmoStore((state) => state.clearError);

	useEffect(() => {
		clearError();
	}, [clearError]);

	return (
		<Page.Section
			fullHeight
			style={{padding: '0px'}}
		>
			<Layout fullWidth direction="column">
				{
					error && (
						<Layout fullWidth>
							<SlideInWarnings
								warnings={telenorApiWarning}
								endBorderRadius
								variant="error"
							/>
						</Layout>
					)
				}
				<Layout
					fullWidth
					style={{padding: error ? '0px 16px' : '16px'}}
				>
					<TicketForm />
				</Layout>
			</Layout>
		</Page.Section>
	);
};

export default CreateTicketTab;
